// Vendors
import React from 'react';

// Components
import { SearchBox, MenuSelect } from '../../algolia/components';
import sortAlphaByProperty from '../../lib/utilities/sortAlphaByProperty';

const RebatesSearchFilters = () => (
  <div className="grid grid--gutter grid--gutter-xs">
    <div className="grid__col-xs-12 grid__col-md-12 grid__col-lg-4">
      <SearchBox
        searchAsYouType={true}
        name="search"
        label="Search State Rebate Database..."
        className="u--margin-bottom-0"
      />
    </div>
    <div className="grid__col-xs-12 grid__col-md-12 grid__col-lg-5 grid__col-lg-offset-3">
      <div className="grid grid--gutter grid--gutter-xs">
        <div className="grid__col-xs-12 grid__col-sm-6">
          <MenuSelect
            name="projectType"
            attribute="facets.rebate_project_type"
            emptyOptionLabel="Filter by Project Type"
            className="u--margin-bottom-0"
          />
        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <MenuSelect
            name="region"
            attribute="facets.rebate_region"
            limit={100}
            transformItems={(items) => sortAlphaByProperty(items, 'label')}
            emptyOptionLabel="Filter by State/Region"
            className="u--margin-bottom-0"
          />
        </div>
      </div>
    </div>
  </div>
);

export default RebatesSearchFilters;
